export default __webpack_public_path__ + "static/media/Fauld of the Steel Behemoth.8ddfde25.jpg";